import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiModule } from '@components/ui/ui-module';
import { environment } from '@environments/environment';
import { Router } from '@services/route.service';

@Component({
  selector: 'op-menu',
  imports: [
    RouterModule,
    UiModule
  ],
  templateUrl: './menu.html',
  styleUrl: './menu.css',
})
export class Menu {
  readonly router=inject(Router);
  readonly url: string=`${environment.app_url}/install`;
  readonly urlCGV: string=`${environment.app_url}/conditions-generales-de-vente`;
}
